import { useQuery } from "@tanstack/react-query";
import { useGooglePlaces } from "./useGooglePlaces";
import { useUserLocation } from "./useLocation";

const SEEKER_STATE_STALE_TIME = 1000 * 60 * 60 * 24;

export function useSeekerState(): string | undefined {
    const { location } = useUserLocation();
    const { reverseGeocode } = useGooglePlaces();
    const lat = location?.lat;
    const lon = location?.lon;
    const hasLocation = lat != null && lon != null;

    const { data } = useQuery({
        queryKey: hasLocation
            ? (["seeker-state", lat, lon] as const)
            : (["seeker-state", null, null] as const),
        enabled: hasLocation,
        queryFn: async () => {
            const result = await reverseGeocode(lat as number, lon as number);
            return result?.state?.trim() || null;
        },
        staleTime: SEEKER_STATE_STALE_TIME,
    });

    return data ?? undefined;
}
